import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { CmsPostContainerModel } from '../../../../../models/aggregates/erp/cms-post';
import { Observable } from 'rxjs';
import { BasicApiResponseModel } from '../shared/api-response.model';
import { ApiVisa } from '../shared';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { FinancialItemContainerModel } from '../../../../../models/aggregates/erp/financial';
import { FiItemViewContainerModel } from '../../../../../models/aggregates/fi-item-view/fi-item-view-container.model';

@Injectable({
  providedIn: 'root'
})
export class FiItemViewService extends BaseApiPublicLoginTemplateService<FiItemViewContainerModel,FiItemViewContainerModel,FiItemViewContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'item-view-hdrs/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'item-view-hdrs/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'item-view-hdrs/' + BaseApiTemplateService.PUBLIC_EP;
    this.httpClient = http;
  }

  getFiItemWithIncrementedViewCountUpsertPublic(itemHdrGuid: string, cookieValue: string,  visa: ApiVisa): Observable<BasicApiResponseModel<FinancialItemContainerModel>>{
    const publicUrl = visa.api_domain_url ?
    visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'item-view-hdrs/upsert-view/'+ itemHdrGuid + '/' + cookieValue + '/' + BaseApiTemplateService.PUBLIC_EP
    : Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'item-view-hdrs/upsert-view/'+ itemHdrGuid + '/' + cookieValue + '/' + BaseApiTemplateService.PUBLIC_EP
    
    return this.httpClient.get<BasicApiResponseModel<FinancialItemContainerModel>>(
      publicUrl,
      this.getHttpHeader(visa)
    );
  }

}